




























































































import Enumerable from "linq";
import { DialogMixin, ModelEditableMixin } from "../../../../../../../base/components/system/mixins";
import { Component, Mixins } from "vue-property-decorator";
import { FormatStructureEditableMixin } from "../../../mixins";
import { IDateCalculateItem, IDateCalculateObject, instanceOfIDateCalculateNumber } from "../../../../../../../documaker/domain/format/objects";
import { NumberInput } from "../../../../../../../base/components/system";
import { ElTable } from "element-ui/types/table";
import { DateCalculateSelector } from "../selectors";

@Component({
  components: {
    settableCalculateSelector: DateCalculateSelector,
    settingCalculateSelector: DateCalculateSelector,
    NumberInput,
  },
})
export default class DateCalculateEditDialog extends Mixins(DialogMixin, ModelEditableMixin, FormatStructureEditableMixin) {
  baseDateObjectItems: IDateCalculateItem[] = [];
  settableItems: IDateCalculateItem[] = [];
  settingCalculateItems: IDateCalculateItem[] = [];
  edittingCalculateDate: number = null;
  selectedBaseCalculate: IDateCalculateItem = null;
  selectedSettableItems: IDateCalculateItem[] = [];
  selectedSettingItems: IDateCalculateItem[] = [];
  confirmSelected: boolean = false;

  $refs!: {
    baseDateTable: ElTable,
  };

  get hasEdittingCalculateDate(): boolean {
    return !!this.edittingCalculateDate ;
  }

  get hasSelectedSettableItems(): boolean {
    return (this.selectedSettableItems.length > 0);
  }

  get hasSelectedSettingItems(): boolean {
    return (this.selectedSettingItems.length > 0);
  }

  get isTopSelectedItem(): boolean {
    return this.hasSelectedSettableItems && this.selectedSettingItems.some(v => v === this.settingCalculateItems[0]);
  }

  get isBottomSelectedItem(): boolean {
    return this.hasSelectedSettableItems && this.selectedSettingItems.some(v => v === this.settingCalculateItems[this.settingCalculateItems.length - 1]);
  }

  get previewText(): string {
    let text = "";
    if (!!this.selectedBaseCalculate) {
      text += (this.selectedBaseCalculate.reference as IDateCalculateObject).name;
    }
    if (this.settingCalculateItems.length > 0) {
      Enumerable.from(this.settingCalculateItems).forEach(s => {
        text += (s.reference.operator === "1") ? " + " : " - ";
        text += instanceOfIDateCalculateNumber(s.reference)
          ? s.reference.value
          : s.reference.name;
      });
    }
    return text;
  }

  set previewText(text: string) {
  }

  get isStepEnable(): boolean {
    return true;
  }

  get isIndexColumnEnable(): boolean {
    return true;
  }

  get isOperationColumnEnable(): boolean {
    return true;
  }

  get isPreviewEnable(): boolean {
    return false;
  }

  async show(baseItems: IDateCalculateItem[], settableItems: IDateCalculateItem[], settingItems: IDateCalculateItem[]): Promise<IDateCalculateItem[]> {
    return this.showModal(async () => {
      this.settableItems = settableItems;
      this.settingCalculateItems = this.getsettingCalculateItems(settingItems);
      this.baseDateObjectItems = baseItems;
      const selectedCalculate = this.getSelectedBaseDateCalculateItem(settingItems);
    
      const row = (!selectedCalculate)
        ? null
        : Enumerable.from(this.baseDateObjectItems)
          .firstOrDefault(i => 
            !instanceOfIDateCalculateNumber(i.reference)
            && !instanceOfIDateCalculateNumber(selectedCalculate.reference)
            && i.reference.key === selectedCalculate.reference.key);
      this.$nextTick(() => {
        this.$refs.baseDateTable.setCurrentRow(null);
        if (!!row) {
          this.$refs.baseDateTable.setCurrentRow(row);
          this.selectedBaseCalculate = row;
        }
      });

      this.confirmSelected = false;
      await this.waitHidden();
      let result = [] as IDateCalculateItem[];
      if (!!this.selectedBaseCalculate) {
        // 基準日に operator 属性はつかないため値無しにする
        this.selectedBaseCalculate.reference.operator = undefined;
        result = result.concat(this.selectedBaseCalculate); 
      }
      if (this.settingCalculateItems.length > 0) { result = result.concat(this.settingCalculateItems); }
      return this.confirmSelected ? result : null;
    });
  }

  private getsettingCalculateItems(items: IDateCalculateItem[]): IDateCalculateItem[] {
    // 基準日を除く
    return Enumerable.from(items).where(i => instanceOfIDateCalculateNumber(i.reference) || i.reference.type !== "date").toArray();
  }

  // 設定されている基準日を取得
  private getSelectedBaseDateCalculateItem(items: IDateCalculateItem[]): IDateCalculateItem {
    return Enumerable.from(items).firstOrDefault(i => !instanceOfIDateCalculateNumber(i.reference) && i.reference.type === "date");
  }

  addCalculateNumber() {
    this.settingCalculateItems = this.settingCalculateItems.concat({
      isObject: false,
      reference: {
        itemType: "2",
        option: "1",
        operator: "1",
        value: this.edittingCalculateDate,
      },
    });
  }

  addCalculateObject() {
    this.settingCalculateItems = this.settingCalculateItems.concat(
      Enumerable.from(this.selectedSettableItems).select(s => {
        const calculateObj = s.reference as IDateCalculateObject;
        return {
          isObject: s.isObject,
          reference: {
            itemType: calculateObj.itemType,
            option: calculateObj.option,
            operator: calculateObj.operator,
            id: calculateObj.id,
            type: calculateObj.type,
            key: calculateObj.key,
            name: calculateObj.name,
          }
        };
      }).toArray());
  }

  baseCalculateClick(row: IDateCalculateItem) {
    this.selectedBaseCalculate = row;
  }

  settableItemSelectionChange(value: IDateCalculateItem[]) {
    this.selectedSettableItems = value;
  }

  settingItemsSelectionChange(value: IDateCalculateItem[]) {
    this.selectedSettingItems = value;
  }

  moveItems(offset: number) {
    const indexes = this.selectedSettingItems.map(v => this.settingCalculateItems.indexOf(v)).sort((a, b) => a - b);
    if (offset > 0) {
      indexes.reverse();
    }
    indexes.forEach(i => this.moveItem(i, offset));
  }

  private moveItem(index: number, offset: number) {
    const item = this.settingCalculateItems[index];
    this.settingCalculateItems.splice(index, 1);
    this.settingCalculateItems.splice(index + offset, 0, item);
  }

  removeItems() {
    this.settingCalculateItems = this.settingCalculateItems.filter((v) => !this.selectedSettingItems.some(s => s === v));
  }

  confirmSelect(): void {
    this.confirmSelected = true;
    this.isVisible = false;
  }

  cancelSelect(): void {
    this.isVisible = false;
  }

  correct(value: number): number {
    return Math.floor(value);
  }

  toDateCalculateItemName(row: IDateCalculateItem): string {
    return instanceOfIDateCalculateNumber(row.reference) ? "固定日数" : row.reference.name;
  }
}
